if($('#article-actions').length){
    var app = new Vue({
        el: '#article-actions',
        data: {
            likesCount:null,
            likesImages:{},
            liked:false,
            model:polymorphicModel,
            id:polymorphicId,
            userId:userId,
            loaded:false
        },
        methods: {
            getCount(){
                axios.get('/api/v1/likes/'+this.model+'/'+this.id+'/count')
                .then((response) =>  {
                    this.likesCount = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                })
            },
            getImages(){
                axios.get('/api/v1/likes/'+this.model+'/'+this.id+'/images')
                .then((response) =>  {
                    this.likesImages = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                })
            },
            userLiked(){
                axios.get('/api/v1/likes/'+this.model+'/'+this.id+'/liked')
                .then((response) =>  {
                    if(response.data){
                        this.liked = true;
                    }else{
                        this.liked = false;
                    }
                    this.$nextTick(function () {
                        $(".tooltipped").tooltip();
                    });
                })
                .catch(function (error) {
                    console.log(error);
                })
            },
            createLike(){
                if(!userId){
                    window.location = '/register';
                }else{
                    axios.post('/api/v1/likes/'+this.model+'/'+this.id+'/create')
                    .then((response) =>  {
                        this.userLiked();
                        this.getCount();
                        this.getImages();

                        this.$toasted.success('You have liked the Article');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            destroyLike(){
                axios.delete('/api/v1/likes/'+this.model+'/'+this.id+'/destroy')
                .then((response) =>  {
                    this.userLiked();
                    this.getCount();
                    this.getImages();

                    this.$toasted.info('You have unliked the Article');
                })
                .catch(function (error) {
                    console.log(error);
                })
            }
        },
        mounted () {
            if (this.userId) {
                this.userLiked();
            }
            this.getCount();
            this.getImages();
        }
    });
}